/*
  OFFE (Rachel, Oct 28, 2026) - cart drawer order summary helpers.
  Markup: snippets/offe-drawer-summary.liquid.
  1. Shipping by ZIP: only shown when the bag has a Shopify Collective item
     (those ship at the brand's rates). Asks Shopify for the bag's shipping
     rates to that ZIP and shows the cheapest one plus the estimated total.
     The ZIP is remembered for this visit and re-estimated when the bag
     changes. Shopify needs the state too, so it is worked out from the
     ZIP (US) or the postal code's first letter (Canada).
  2. "These are cute too...": when the bag has fewer than 3 items, fills the
     row with Shopify's recommendations for the first item in the bag
     (sections/cart-notification-recommend.liquid, ShipAid already left out),
     skipping anything already in the bag. 4 cards, 2 across.
  3. Discount code clean-up: the theme's discount field leaves a code that
     doesn't work on the bag stuck to the cart (it shows the error but keeps
     the code). After an Apply, codes that don't apply are taken back off.
  The theme redraws the whole drawer after every change, so this re-runs
  whenever the drawer's contents are swapped.
*/
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var recCache = {};
  var ZIP_KEY = 'offeShipZip';

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function getZip() { try { return sessionStorage.getItem(ZIP_KEY) || ''; } catch (e) { return ''; } }
  function setZip(z) { try { sessionStorage.setItem(ZIP_KEY, z); } catch (e) {} }

  // first 3 digits of a US ZIP -> state
  var US = [[5,5,'NY'],[6,9,'PR'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[55,55,'MA'],[50,59,'VT'],[60,69,'CT'],
    [70,89,'NJ'],[90,99,'AE'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,200,'DC'],[201,201,'VA'],[202,205,'DC'],[206,219,'MD'],
    [220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[320,349,'FL'],[350,369,'AL'],[370,385,'TN'],
    [386,397,'MS'],[398,399,'GA'],[400,427,'KY'],[430,458,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],
    [550,567,'MN'],[569,569,'DC'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],
    [680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[733,733,'TX'],[730,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],
    [832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[885,885,'TX'],[889,898,'NV'],[900,961,'CA'],[962,966,'AP'],
    [967,968,'HI'],[969,969,'GU'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']];
  var CA = { A: 'NL', B: 'NS', C: 'PE', E: 'NB', G: 'QC', H: 'QC', J: 'QC', K: 'ON', L: 'ON', M: 'ON', N: 'ON', P: 'ON', R: 'MB', S: 'SK', T: 'AB', V: 'BC', X: 'NT', Y: 'YT' };
  function province(zip, country) {
    if (country === 'US') {
      var n = parseInt(zip.replace(/\D/g, '').slice(0, 3), 10);
      if (isNaN(n)) return '';
      for (var i = 0; i < US.length; i++) if (n >= US[i][0] && n <= US[i][1]) return US[i][2];
      return '';
    }
    if (country === 'CA') return CA[zip.trim().charAt(0).toUpperCase()] || '';
    return '';
  }

  function rates(zip, country) {
    var prov = province(zip, country);
    var q = 'shipping_address%5Bzip%5D=' + encodeURIComponent(zip) + '&shipping_address%5Bcountry%5D=' + encodeURIComponent(country) +
      (prov ? '&shipping_address%5Bprovince%5D=' + prov : '');
    return fetch(root + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST' }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      var tries = 0;
      function poll() {
        return fetch(root + 'cart/async_shipping_rates.json?' + q).then(function (r2) {
          if (r2.status === 202 || r2.status === 204) {
            if (++tries > 12) throw { error: 'timeout' };
            return new Promise(function (res) { setTimeout(res, 500); }).then(poll);
          }
          return r2.json().then(function (j) { if (!r2.ok) throw j; return j; });
        });
      }
      return poll();
    });
  }

  function estimate(sum, form, zip) {
    var shipEl = sum.querySelector('[data-offe-ship]');
    var estRow = sum.querySelector('[data-offe-est-row]');
    var estEl = sum.querySelector('[data-offe-est]');
    var msg = form.querySelector('[data-offe-zip-msg]');
    var btn = form.querySelector('button');
    msg.hidden = true;
    shipEl.innerHTML = '<span class="offe-dsum__muted">Checking&hellip;</span>';
    btn.disabled = true;
    rates(zip, sum.getAttribute('data-country') || 'US').then(function (j) {
      var list = (j && j.shipping_rates) || [];
      btn.disabled = false;
      if (!list.length) {
        shipEl.innerHTML = '<span class="offe-dsum__muted">Calculated at checkout</span>';
        msg.textContent = 'We couldn’t find a rate for that ZIP. You’ll see it at checkout.';
        msg.hidden = false;
        estRow.hidden = true;
        return;
      }
      var best = list.reduce(function (a, b) { return parseFloat(b.price) < parseFloat(a.price) ? b : a; });
      var cents = Math.round(parseFloat(best.price) * 100);
      shipEl.innerHTML = cents === 0 ? '<span class="offe-dsum__free">Free</span>' : money(cents);
      var sub = parseInt(sum.getAttribute('data-subtotal'), 10) || 0;
      estEl.textContent = money(sub + cents);
      estRow.hidden = false;
      msg.textContent = 'To ' + zip;
      msg.hidden = false;
    }).catch(function () {
      btn.disabled = false;
      shipEl.innerHTML = '<span class="offe-dsum__muted">Enter ZIP below</span>';
      msg.textContent = 'Please check the ZIP code and try again.';
      msg.hidden = false;
      estRow.hidden = true;
    });
  }

  function setupZip(sum) {
    var form = sum.querySelector('[data-offe-zip]');
    if (!form || form._offe) return;
    form._offe = true;
    var input = form.querySelector('input');
    var saved = getZip();
    if (saved) input.value = saved;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var z = input.value.trim();
      if (!z) { input.focus(); return; }
      setZip(z);
      estimate(sum, form, z);
    });
    if (saved) estimate(sum, form, saved);
  }

  function fillCute(box) {
    if (box._offe) return;
    box._offe = true;
    var pid = box.getAttribute('data-product-id');
    if (!pid) return;
    var skip = (box.getAttribute('data-exclude') || '').split(',').filter(Boolean);
    var p = recCache[pid] || (recCache[pid] = fetch(root + 'recommendations/products?section_id=cart-notification-recommend&limit=10&product_id=' + pid)
      .then(function (r) { return r.text(); })
      .catch(function () { delete recCache[pid]; return ''; }));
    p.then(function (html) {
      if (!box.isConnected || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var items = Array.prototype.slice.call(doc.querySelectorAll('.cart-notification__recommend-item'));
      var list = box.querySelector('.cart-notification__recommend-list');
      var n = 0;
      items.forEach(function (it) {
        if (n >= 4) return;
        var a = it.querySelector('a[href*="/products/"]');
        var h = a ? (a.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0] : '';
        if (h && skip.indexOf(h) !== -1) return;
        list.appendChild(document.importNode(it, true));
        n++;
      });
      if (n) box.hidden = false;
    });
  }

  // 3. take codes that don't apply back off the cart after an Apply
  var cleanT;
  function cleanCodes() {
    clearTimeout(cleanT);
    cleanT = setTimeout(function () {
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var codes = c.discount_codes || [];
        var bad = codes.filter(function (d) { return d.applicable === false; });
        if (!bad.length) return;
        var keep = codes.filter(function (d) { return d.applicable !== false; }).map(function (d) { return d.code; });
        fetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: keep.join(',') })
        });
      });
    }, 2500);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.cart-drawer .cart-discount-code__submit')) cleanCodes();
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target.closest && e.target.closest('.cart-drawer .cart-discount-code')) cleanCodes();
  }, true);

  function run() {
    document.querySelectorAll('.cart-drawer .offe-dsum').forEach(setupZip);
    document.querySelectorAll('.cart-drawer [data-offe-cute]').forEach(fillCute);
  }

  function start() {
    run();
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 40); })
      .observe(drawer.parentElement || drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
